export interface TranslateResponseDto {
  exception_code: string;
  matches: {
    id: string;
    segment: string;
    translation: string;
    source: string; // NOTE en-GB,
    target: string; // NOTE ar-SA,
    quality: number;
    reference: unknown;
    'usage-count': number;
    subject: string;
    'created-by': string;
    'last-updated-by': string;
    'create-date': string;
    'last-update-date': string;
    match: number;
  }[];
  mtLangSupported: unknown;
  quotaFinished: boolean;
  responderId: string;
  responseData: {
    match: number;
    translatedText: string;
  };
  responseDetails: string;
  responseStatus: number;
}
